import { environment } from 'src/environments/environment';

export const AppConfig = {
  name: `Bonos Consuma`,
  keywords: `Bonos, Consuma, Bonos Consuma, Concello, Ames`,
  description: `Bonos Consuma, Concello de Ames`,
  urlToClientApp: `https://app.bonosconsuma.gal`,
  version: environment.version,
};
